// services.js

import { request } from "../../api/api";
export const getPlanList = () => {
  return request.get(`/plans/`);
};
export const getPlanById = (id) => {
  return request.get(`/plans/${id}`);
};
export const addPlan = (data) => {
  return request.post(`/plans/`, data);
};
export const updatePlanStatus = (data) => {
  return request.post(`/plans-update-status/`, data);
};
export const UpdatePlanById = (id, data) => {
  return request.put(`/plans/${id}`, data);
};

// New function to delete a plan
export const deletePlanById = (id) => {
  return request.delete(`/plans/${id}`);
};

export const userSubscription = (options = {}) => {
  const { page = 1, page_size = 5, search = "", status = "" } = options;
  return request.get(
    `/user-subscriptions/?page=${page}&page_size=${page_size}&search=${search}&status=${status}`
  );
};

export const userSubscriptionId = (id) => {
  return request.get(`/user-subscriptions/${id}/`);
};

export const deleteUserSubscription = (id) => {
  return request.delete(`/user-subscriptions/${id}/delete/`);
};

export const userPayment = (options = {}) => {
  const { page = 1, page_size = 10 } = options;
  return request.get(`/payments/?page=${page}&page_size=${page_size}`);
};

export const userPaymentId = (id) => {
  return request.get(`/payments/${id}/`);
};

export const deleteUserPayment = (id) => {
  return request.delete(`/payments/${id}/delete`);
};
